<template>
    <div class="footer-container">
        <div class="footer-box">
            <div class="f0">
                <div class="infos-box icon-sty36">
                    <div class="icon-sty36-box">
                        <div><img v-lazy="iconObj.icon_facebook" alt="" @click="gotoWebsite('facebook')" /></div>
                        <div><img v-lazy="iconObj.icon_youtube" alt="" @click="gotoWebsite('youtube')" /></div>
                        <div><img v-lazy="iconObj.icon_instagram" alt="" @click="gotoWebsite('instagram')" /></div>
                        <div><img v-lazy="iconObj.icon_twitter" alt="" @click="gotoWebsite('twitter')" /></div>
                        <div><img v-lazy="iconObj.icon_linkin" alt="" @click="gotoWebsite('linkin')" /></div>
                    </div>
                </div>

                <div class="infos-box icon-sty24">
                    <img v-lazy="iconObj.icon_com" alt="" />{{ $t('index.company_name') }}
                </div>
                
                <div class="infos-box icon-sty24">
                    <img v-lazy="iconObj.icon_mail" alt="" /><span>{{ $t('index.email_colin') }}</span>
                </div>
                
                <div class="infos-box icon-sty24">
                    <img v-lazy="iconObj.icon_local" alt="" />{{ $t('index.company_address') }}
                </div>
            </div>

            <div class="f2">
                {{ $Common.toSprintf($t('index.copyright'), thisYear) }}
            </div>
        </div>
    </div>
</template>

<script>
/**
 * Common Right Contact Us
 */
/* import contactWechatImg  from '@/../public/static/imgs/wechat/summer.png';
import contactDemoAppImg from '@/../public/static/imgs/wechat/demo-app.png'; */
import { goToHome } from '@/utils/routerUtils';

export default {
    name: 'CommonBottomFooterMenu',
    data() {
        return {
            // contactWechatImg,
            // contactDemoAppImg,
            tips   : 'Hello World',
            iconObj: {
				icon_com      : require('@/assets/static/imgs/common/icon_com.png'),
				icon_mail     : require('@/assets/static/imgs/common/icon_mail.png'),
				icon_local    : require('@/assets/static/imgs/common/icon_local.png'),
				icon_facebook : require('@/assets/static/imgs/common/icon_facebook.png'),
				icon_youtube  : require('@/assets/static/imgs/common/icon_youtube.png'),
				icon_instagram: require('@/assets/static/imgs/common/icon_instagram.png'),
				icon_twitter  : require('@/assets/static/imgs/common/icon_twitter.png'),
				icon_linkin   : require('@/assets/static/imgs/common/icon_linkin.png'),
				logo_w        : require('@/assets/static/imgs/common/logo-w.png')
			}
        }
    },

    methods: {
        handleError(event)
        {
            /* console.log('event >>>', event);
            event.target.src = require('@/assets/static/imgs/common/google-cloud.png'); */
        },

        // 跳转至首页
		goHome()
		{
			goToHome(this.$router);
		},

        gotoWebsite(type)
        {
            switch(type)
            {
                case 'facebook':
                    window.open('https://www.facebook.com/profile.php?id=61557913743944');
                    break;
                case 'youtube':
                    window.open('https://www.youtube.com/channel/UCB2i266KFFcfmfiUTX5mk7g');
                    break;
                case 'instagram':
                    window.open('https://www.instagram.com/bytesungame/');
                    break;
                case 'twitter':
                    window.open('https://twitter.com/BytesunGame');
                    break;
                case 'linkin':
                    window.open('https://www.linkedin.com/company/bytesun-game/?viewAsMember=true');
                    break;
            }
        }
    },

    computed: {
		thisYear()
        {
            return new Date().getFullYear();
        }   
	}
}
</script>

<style lang="less" scoped>
.footer-container{
    width:var(--com-base-container-wm);height:420px;
    display:flex;justify-content:center;align-items:flex-start;
    padding-top:50px;
    background:#13144D;
    .footer-box{
        position:relative;
        display:flex;flex-direction:column;justify-content:center;align-items:center;
        width:var(--com-base-content-wm);height:auto;
        /* background:rgb(255, 0, 0); */
        font-family:var(--com-number-coin-fm-L);font-size:var(--com-base-fz-14);text-align:center;
        .f0{
            display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;
            width:100%;height:inherit;
            font-size:var(--com-base-fz-24);text-align:left;
            div, span{
                font-family:var(--com-number-coin-fm-R);color:#FFF;/* font-weight:bold; */
            }
            .infos-box{
                display:flex;justify-content:flex-start;align-items:center;
                height:auto;
                text-decoration:none;
                a{
                    text-decoration:none;
                }
                span{
                    text-decoration:none;
                }
            }
            .pl-0{
                padding-left:0px;
            }
            .icon-sty24{
                height:50px;line-height:50px;
                img{
                    width:24px;height:24px;
                    margin-right:10px;
                }
            }
            .icon-sty36{
                margin-bottom:25px;
                .icon-sty36-box{
                    width:auto;height:84px;
                    display:flex;justify-content:flex-start;align-items:center;
                    div{
                        display:flex;justify-content:center;align-items:center;
                        width:84px;height:84px;
                        margin-right:25px;
                        border-radius:50%;
                        background:#1C1E5B;
                    }
                    img{
                        width:36px;height:36px;
                    }
                }
            }
            .channels-list-box{
                width:290px;
                padding:15px;
                display:flex;align-items:flex-start;flex-wrap:wrap;
                gap:40px 40px;
                i{
                    width:60px;height:60px;
                    font-size:var(--com-base-fz-50);color:#000;
                }
            }
        }
        .f2{
            /* position:absolute;bottom:0;left:0;right:0;margin:auto; */
            display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-end;
            width:100%;height:60px;
            margin-top:25px;padding-left:31px;
            border-top:2px solid #2B2C68;
            font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-22);color:#7D7EA8;text-align:left;
        }
    }
}
</style>
